var map = {
	"./12_core.jpg": "+n4I",
	"./MIT_950.jpg": "62yl",
	"./TQ_pyramid.png": "2e+2",
	"./amazon.png": "QJr7",
	"./amazon2.png": "J71W",
	"./amazonuk.png": "kXgN",
	"./blog_placeholder.png": "H2QI",
	"./china.png": "Him2",
	"./danah_bg.jpeg": "hO/f",
	"./danah_fullbg.jpeg": "xB+S",
	"./danah_profile.jpg": "M43M",
	"./en.png": "nLGm",
	"./gatsby-astronaut.png": "qRbu",
	"./gatsby-icon.png": "waaq",
	"./header1.jpeg": "c8vQ",
	"./header2.jpg": "pLso",
	"./header3.jpg": "Dxh4",
	"./mckinsey.jpg": "8Yln",
	"./mckinsey_950.jpg": "mOIb",
	"./profile.png": "7pzU",
	"./ql_book.jpg": "LO22",
	"./qself_book.jpeg": "JCMG",
	"./qsociety_book.jpg": "qFh2",
	"./quote_1.png": "Z+0n",
	"./quote_2.png": "vh2x",
	"./rewiring_book.jpg": "AJrj",
	"./scapital_book.jpg": "iCf0",
	"./spiritual2.png": "FWE5",
	"./spiritual_capital_book.jpg": "FiI6",
	"./sq1_book.jpg": "qCx+",
	"./sq2_book.jpg": "W4XD",
	"./svg/logo.svg": "yqjV",
	"./table_intelligence.jpg": "v8XW",
	"./video1.png": "f8lF",
	"./video2.png": "FISk",
	"./video3.png": "WYHK",
	"./wealth2.png": "am4v",
	"./whoafraid_book.jpg": "rscx"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a2qD";